import React, { createRef, useEffect } from "react";

import "./select.css";
import useIsMountedRef from "../../utils/mountedRef";

const SelectDepartement = (props) => {
  const refSelect = createRef();
  const isMountedRef = useIsMountedRef();

  function EventChange(refPassed, value, chiffre) {
    props.handleChange(props.setter, parseInt(value)); // launch handleChange in parent simu
    if (chiffre !== undefined && props.setDepartementChiffre) {
      props.handleChange(props.setDepartementChiffre, parseInt(chiffre));
    }
  }

  //SET THE DEPT CHIFFRE LINKED TO USER'S DEPT
  useEffect(() => {
    let id;

    if (props.defaultValue > 0) {
      if (props.defaultValue === 976) {
        id = props.items[99]?.DepartementChiffreID;
      } else if (props.defaultValue > 94) {
        id = props.items[props.defaultValue - 876]?.DepartementChiffreID;
      } else {
        id = props.items[props.defaultValue - 1]?.DepartementChiffreID;
      }
    }

    EventChange(refSelect, props.defaultValue, id);
  }, [isMountedRef]);

  return (
    <select
      className={"select_custom"}
      ref={refSelect}
      defaultValue={props.defaultValue || "Sélectionnez un département"}
      onChange={(e) => {
        const chiffre = e.target.selectedOptions[0].getAttribute('chiffre');
        EventChange(refSelect, e.target.value, chiffre);
      }}
    >
      <option></option>
      {props.items.map((item, key) => {
        return (
          <option
              key={key}
              value={item[props.optionValue]}
              chiffre={props.setDepartementChiffre ? item["DepartementChiffreID"] : undefined}
          >
            {item.id === 998 || item.id === 999 ? "" : item[props.nameField]}
          </option>
        );
      })}
    </select>
  );
};

export default SelectDepartement;
